import { defineRoutes } from '#utils';

export const routes = defineRoutes({
  ringcentral: {
    email: {
      unsubscribe: {
        create: '/ringcentral/email/unsubscribe',
      },
    },
  },
});
